export default __webpack_public_path__ + "static/media/services_dev_custom.fa8e3afe.svg";